import { Box, Button, DialogContent, keyframes, Typography } from "@mui/material";
import GlobalDialogContent from "../GlobalDialogContent";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { showSnackbar } from "../../../redux/reducer/snackbarSlice";
import { closeDialog } from "../../../redux/reducer/dialogSlice";
import { setModuleRefresh } from "../../../redux/reducer/registration/RefreshSlice";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const SewaDeleteDialog = () => {
  const payload = useSelector((state: RootState) => state.dialog.payload);
  const dispatch = useDispatch();

  const handleDelete = async () => {
    const reqPayload = { id: payload?.id };

    const { code, message } = await payload?.deleteService(reqPayload);

    if (code === 200) {
      dispatch(closeDialog());
      dispatch(setModuleRefresh({ moduleName: payload?.moduleName, refresh: true }));
      dispatch(showSnackbar({ type: 'success', message: message || 'Deleted Successfully' }));
    } else {
      dispatch(showSnackbar({ type: 'error', message }));
    }
  };

  const floatAnimation = keyframes`
    0% { transform: translateY(0px); }
    50% { transform: translateY(-8px); }
    100% { transform: translateY(0px); }
  `;

  return (
    <GlobalDialogContent
      dialogBody={
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ display: 'flex', textAlign: 'left' }}>
            <Box sx={{ animation: `${floatAnimation} 3s ease-in-out infinite` }}>
              <img
                src="/delete.png"
                alt="Delete Icon"
                width="100"
                height="100"
                style={{ filter: "drop-shadow(3px 5px 1px rgba(0,0,0,0.3))" }}
              />
            </Box>

            <Typography variant="h6" sx={{ pl: 5, pt: 2 }}>
              {payload?.message}{" "}
              <strong>"{payload?.name}"</strong>. This will be removed permanently.
            </Typography>
          </Box>
        </DialogContent>
      }
      dialogFooter={
        <Button
          onClick={handleDelete}
          variant="contained"
          color="primary"
          endIcon={<DeleteOutlineIcon />}
        >
          {payload?.buttonText || "Delete"}
        </Button>
      }
    />
  );
};

export default SewaDeleteDialog;
